module.exports = __webpack_public_path__ + "static/DessertJap-ab1ebf115c4e483d52723d79202796b5.png";